import $ from 'jquery';
import _ from 'lodash-es';
import { product_carousels, quickview_carousels } from './carousel';

const processVariantSelectors = (type, e) => {
  const $variant_selector = $(e.currentTarget);
  const $container = $variant_selector.closest('[data-section-type="product"]');
  const $option_selector = $variant_selector.closest('[data-custom-option-selector]');
  const $shopify_selector = $($option_selector.data('shopifyOptionSelector'), $container);
  let value;
  
  if (type === 'list') {
    $option_selector.find('[data-custom-variant-selector]').removeClass('ProductOption__variant--selected');
    $variant_selector.addClass('ProductOption__variant--selected');
    value = $variant_selector.data('value');
  } else if (type === 'select') {
    value = $variant_selector.val();
  }

  if (!value) {
    // WEIRD BEHAVIOR WITH IOS AND SELECTRIC:
    // We're in the middle of choosing a value via the native select picker, but selectric triggers the change event.
    // We haven't hit "done" yet so the value is technically undefined...we're basically in limbo.
    // It will trigger another change event once we actually make our selection, so this is just extra/premature.
    // Just return so we don't cause problems...the final change event will go through fine.
    return;
  }

  $shopify_selector.val(value).trigger('change');

  // Check for any invalid/unavailable or sold out options and disable them
  const product_json = JSON.parse($('[data-product-json]', $container).html());
  const current_option1 = $('#SingleOptionSelector-0', $container).val();
  const current_option2 = $('#SingleOptionSelector-1', $container).val();
  const current_option3 = $('#SingleOptionSelector-2', $container).val();

  if (type === 'list') {
    $('[data-custom-variant-selector]', $container).removeClass('ProductOption__variant--unavailable').removeClass('ProductOption__variant--sold-out');

    $('[data-custom-variant-selector]', $container).each((i, selector) => {
      const $selector = $(selector);
      const closest_selector = $selector.closest('[data-custom-option-selector]').data('customOptionSelector');

      // If this product has 2 or more options and this selector is an option 1, just get out of here...we don't need to process this
      if (closest_selector === 'option1' && current_option2) { return; }

      // Similar logic but for 3 options
      if ((closest_selector === 'option1' || closest_selector === 'option2') && current_option3) { return; }

      let variant_name = $selector.data('value');

      if (closest_selector === 'option2') {
        variant_name = `${current_option1} / ${$selector.data('value')}`;
      }

      if (closest_selector === 'option3') {
        variant_name = `${current_option1} / ${current_option2} / ${$selector.data('value')}`;
      }

      const variant = _.find(product_json.variants, { title: variant_name });

      if (!variant) {
        // Doesn't exist at all...unavailable
        $selector.addClass('ProductOption__variant--unavailable');
      } else if (!variant.available) {
        // Exists, but sold out
        $selector.addClass('ProductOption__variant--sold-out');
      }            
    });

    // Special logic for 3 option products...
    if (current_option3) {
      $('[data-custom-option-selector="option2"] [data-custom-variant-selector]', $container).each((index, selector) => {
        const $selector = $(selector);
        const variant_prefix = `${current_option1} / ${$selector.data('value')}`;
        
        let variant_found = false;
        let variant_in_stock = false;

        _.each(product_json.variants, (_variant) => {
          if (_variant.title.indexOf(variant_prefix) !== 0) { return; }
        
          if (!variant_found) {
            variant_found = true;
          }
          
          if (_variant.available && !variant_in_stock) {
            variant_in_stock = true;
          }
        });

        if (!variant_found) {
          // Doesn't exist at all...unavailable
          $selector.addClass('ProductOption__variant--unavailable');
        } else if (!variant_in_stock) {
          // Exists, but sold out
          $selector.addClass('ProductOption__variant--sold-out');
        }
      });
    }

     // Are we currently on an unavailable variant? Change immediately if so
    const $current_unavailable = $('.ProductOption__variant--unavailable.ProductOption__variant--selected', $container);
    if ($current_unavailable.length > 0) {
      if ($('[data-custom-option-selector="option3"]', $container).find('[data-custom-variant-selector]').not('.ProductOption__variant--unavailable').length > 0) {
        $('[data-custom-option-selector="option3"]', $container).find('[data-custom-variant-selector]').eq(0).trigger('click');
        return;
      }

      $('[data-custom-option-selector="option2"]', $container).find('[data-custom-variant-selector]').not('.ProductOption__variant--unavailable').eq(0).trigger('click');
      return;
    }
  } else if (type === 'select') {
    let option_number = 1;

    if ($('[data-custom-option-selector="option2"]', $container).length > 0) {
      option_number = 2;
    }
    if ($('[data-custom-option-selector="option3"]', $container).length > 0) {
      option_number = 3;
    }

    const $selectric = $(`[data-custom-option-selector="option${option_number}"] select`, $container);

    $selectric.find('option').each((i, option) => {
      const $option = $(option);
      let variant_name = $option.attr('value');

      if (option_number === 2) {
        variant_name = `${current_option1} / ${variant_name}`;
      } else if (option_number === 3) {
        variant_name = `${current_option1} / ${current_option2} / ${variant_name}`;
      }

      const variant = _.find(product_json.variants, { title: variant_name });

      $option.removeAttr('disabled');

      if (!variant) {
        // Doesn't exist at all...unavailable
        $option.attr('disabled', true);
      } else if (!variant.available) {
        // Exists, but sold out
        $selectric.closest('.selectric-wrapper').find('li').each((index, li) => {
          const $li = $(li);
          if ($li.text().trim() === $option.attr('value')) {
            $li.addClass('sold-out');
          }
        });
      }
    });

    // Special logic for 3 option products...
    if (current_option3) {
      const $selectric2 = $('[data-custom-option-selector="option2"] select', $container);
      
      $selectric2.find('option').each((i, option) => {
        const $option = $(option);
        const variant_prefix = `${current_option1} / ${$option.attr('value')}`;
        
        let variant_found = false;
        let variant_in_stock = false;

        _.each(product_json.variants, (_variant) => {
          if (_variant.title.indexOf(variant_prefix) !== 0) { return; }
        
          if (!variant_found) {
            variant_found = true;
          }
          
          if (_variant.available && !variant_in_stock) {
            variant_in_stock = true;
          }
        });

        $option.removeAttr('disabled');

        if (!variant_found) {
          // Doesn't exist at all...unavailable
          $option.attr('disabled', true);
        } else if (!variant_in_stock) {
          // Exists, but sold out
          $selectric2.closest('.selectric-wrapper').find('li').each((index, li) => {
            const $li = $(li);
            if ($li.text().trim() === $option.attr('value')) {
              $li.addClass('sold-out');
            }
          });
        }
      });

       // Are we currently on an unavailable variant? Change immediately if so
      const selected_text = $selectric2.closest('.selectric-wrapper').find('.selected').text().trim();
      const current_value = $selectric2.val();
      if (selected_text !== current_value) {
        $selectric2.prop('selectedIndex', 0).selectric('refresh').trigger('change');
        return;
      }

      $selectric2.selectric('refresh');
    }

    // Are we currently on an unavailable variant? Change immediately if so
    const selected_text = $selectric.closest('.selectric-wrapper').find('.selected').text().trim();
    const current_value = $selectric.val();
    if (selected_text !== current_value) {
      $selectric.prop('selectedIndex', 0).selectric('refresh').trigger('change');
      return;
    }

    $selectric.selectric('refresh');
  }
  
  // Change carousels or slides if necessary
  let carousels = product_carousels;

  if ($container.data('sectionId') === 'QuickView') {
    carousels = quickview_carousels;
  }
  
  const variant_id = $('[data-product-select]', $container).val();
  const $carousels = $('[data-product-images-carousel]', $container);
  const $slide = $carousels.find(`[data-product-images-slide][data-variant-${variant_id}]`).eq(0);

  if (!$slide.length) { return; }

  const slide_index = $slide.index();
  const $carousel = $slide.closest('[data-product-images-carousel]');
  const carousel_id = $carousel.attr('id');
  const $selected_slide = $carousel.find('.is-selected');

  // If the selected slide is already the right variant, don't change slides.
  // This avoids people going back to the first/primary image for a variant just because they changed a secondary option like size
  // Also don't bother if there isn't a slide index...in other words, this variant has no image
  if (!$selected_slide.data()[`variant-${variant_id}`] && slide_index >= 0) {
    carousels[carousel_id].select(slide_index);
  }

  if (!$carousel.hasClass('ProductImages__carousel--active')) {
    $carousels.removeClass('ProductImages__carousel--active');
    $carousel.addClass('ProductImages__carousel--active');

    $('[data-product-images-thumbs]', $container).removeClass('ProductImages__thumbs--active');
    $(`[data-as-nav-for="#${carousel_id}"]`, $container).addClass('ProductImages__thumbs--active');

    window.triggerResize();
  }
};

export default function() {
  $(document).on('click', '[data-custom-variant-selector]:not(.ProductOption__variant--unavailable)', (e) => {
    processVariantSelectors('list', e);
  });

  $(document).on('change', '[data-custom-variant-selector]', (e) => {
    processVariantSelectors('select', e);
  });
}
